module.exports = __webpack_public_path__ + "img/dhl-wallpaper.59f8cbf0.png";